import React from 'react'
import ambassadorPicture from './../Assets/optilume_ambassador_8.png'
import {Link} from 'react-router-dom'
import CardMedia from "@material-ui/core/CardMedia";
import styles from '../App.css'

const AmbassadorLink = () => {
    return (

        <div className='banner-text'>
            <Link to="/ambassador"  target="_blank">
                <CardMedia
                    component='img'
                    image={ambassadorPicture}
                    style={
                        {
                            width: '50%',
                            objectFit: 'inherit',
                            objectPosition: 'bottom',
                            marginLeft: '24%',
                            marginTop: '3%',
                        }}
                />
            </Link>
        </div>
    )
}

export default AmbassadorLink



// WEBPACK FOOTER //
// ./src/Components/AmbassadorLink.js